import { atom } from "jotai"
import { GetRequest } from "../api"
import { urls } from "../constants"
import { alertAtom } from "./globalStateAtoms"


export const BranchBalanceReportData = atom([])
export const fetchBranchBalanceData = atom(null, async (get, set, data,key) => {
  try {
    const res = await GetRequest(urls.getBranchBalanceReport + '?', data)
    if (res.status === 'Success') {
      if (key === 'filterData') {
        if (res?.Data?.table?.length > 0) {
          set(BranchBalanceReportData, res.Data.table)
        } else {
          set(alertAtom, { show: true, msg: 'No Data Found For Selected Date Range', nextId: '' })
          set(BranchBalanceReportData, [])
        }
      }
    }
  } catch (error) {
    console.error('Error fetching Expense Heade:', error)
    set(BranchBalanceReportData, [])
  }
})

const mapTrackingStatusRows = (responseData = {}) => {
  const tableRows = Array.isArray(responseData?.Table) ? responseData.Table : []
  const table1Rows = Array.isArray(responseData?.Table1) ? responseData.Table1 : []

  const statusTypeCounts = tableRows.reduce((result, item) => {
    const type = item?.Type?.toUpperCase()

    if (!type) {
      return result
    }

    result[type] = (result[type] || 0) + 1
    return result
  }, {})

  const scansByEventTypeOnly = table1Rows.reduce((result, item) => {
    const eventType = item?.EventType?.toUpperCase()

    if (!eventType) {
      return result
    }

    if (!result[eventType]) {
      result[eventType] = []
    }

    result[eventType].push(item)
    return result
  }, {})

  const scansByEventType = table1Rows.reduce((result, item) => {
    const eventType = item?.EventType?.toUpperCase()

    if (!eventType) {
      return result
    }

    const eventTypeWithBranch = eventType+'_'+item?.BranchID

    if (!result[eventTypeWithBranch]) {
      result[eventTypeWithBranch] = []
    }

    result[eventTypeWithBranch].push(item)
    return result
  }, {})

  return tableRows.map((item) => {
    const type = item?.Type?.toUpperCase()
    const typeWithBranch = type+'_'+item?.BranchID
    const unitScans = scansByEventType[typeWithBranch] || []
    const fallbackUnitScans = statusTypeCounts[type] === 1 ? scansByEventTypeOnly[type] || [] : []

    return {
      ...item,
      unitScans: unitScans.length > 0 ? unitScans : fallbackUnitScans,
    }
  })
}

export const BookingLRTrackStatusData = atom([])
export const fetchLRStatusData = atom(null, async (get, set, data,key) => {
  try {
    const res = await GetRequest(urls.bookingTrackingStatus + '?', data)
    if (res.status === 'Success') {
      if (res?.Data?.Table?.length > 0) {
          set(BookingLRTrackStatusData, mapTrackingStatusRows(res.Data))
        } else {
          set(alertAtom, { show: true, msg: 'No Data Found', nextId: '' })
          set(BookingLRTrackStatusData, [])
        }
    }
  } catch (error) {
    console.error('Error fetching Expense Heade:', error)
    set(BookingLRTrackStatusData, [])
  }
})
export const ChildCompanyListData = atom([])
export const fetchChildCompanyListData = atom(null, async (get, set, data,key) => {
  try {
    const res = await GetRequest(urls.getChildCompanyListAll + '?', data)
    // if (res.status === 'Success') {
      if (res?.Companies?.length > 0) {
          set(ChildCompanyListData, res?.Companies)
        } else {
          set(alertAtom, { show: true, msg: 'No Data Found', nextId: '' })
          set(ChildCompanyListData, [])
        }
    // }
  } catch (error) {
    console.error('Error fetching Child Company:', error)
    set(ChildCompanyListData, [])
  }
})